"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/ScheduleTab/MessageForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');





var _message = require('shared/validation/team/autoReply/message');

var _Form = require('web/components/Form');












// An auto-reply's message, edited in place in its row.
const MessageForm = ({
  message, onSave, onCancel, canSaveUnchanged = false, isDisabled = false, onDraft,
}) => {
  const id = _react.useId.call(void 0, )
  const { control, formState, handleSubmit, reset, trigger, watch } =
    _reacthookform.useForm({
      mode: 'onChange',
      resolver: _message.autoReplyMessageResolver,
      defaultValues: { autoReplyMessage: message },
    })
  const { isValid, isDirty, isSubmitting, errors } = formState
  const draft = _nullishCoalesce(watch('autoReplyMessage'), () => ( ''))

  // A newly saved message, here or from another device, refills the field.
  // Only a prefilled message that may be saved unchanged is validated up
  // front, so an empty field doesn't open with an error.
  _react.useEffect.call(void 0, () => {
    reset({ autoReplyMessage: message })
    if (canSaveUnchanged) trigger()
  }, [message, canSaveUnchanged, reset, trigger])

  _react.useEffect.call(void 0, () => { _optionalChain([onDraft, 'optionalCall', _ => _(draft)]) }, [draft, onDraft])
  _react.useEffect.call(void 0, () => () => _optionalChain([onDraft, 'optionalCall', _2 => _2(null)]), [onDraft])

  const submit = _react.useCallback.call(void 0, 
    (data) => onSave(data.autoReplyMessage),
    [onSave],
  )

  const cancel = () => {
    reset({ autoReplyMessage: message })
    onCancel()
  }

  return (
    _react2.default.createElement('form', { className: "team-page--message-form", onSubmit: handleSubmit(submit), noValidate: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      , _react2.default.createElement('div', { className: isDisabled ? 'team-page--message-form--off' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        , _react2.default.createElement('label', { className: "team-page--field-label", htmlFor: `${id}-message`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Message")
        , _react2.default.createElement(_Form.InputSectionWrapper, { errorMessage: _optionalChain([errors, 'access', _3 => _3.autoReplyMessage, 'optionalAccess', _4 => _4.message]), className: "team-page--message-form--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
          , _react2.default.createElement(_Form.SimpleTextAreaController, {
            id: `${id}-message`,
            name: "autoReplyMessage",
            control: control,
            maxLength: _message.MAX_AUTOREPLY_MSG_LENGTH,
            rows: 3,
            disabled: isDisabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          )
        )
      )
        , _react2.default.createElement('div', { className: "team-page--form-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
          , _react2.default.createElement(_Form.Button, {
            isSubmit: true,
            isLoading: isSubmitting,
            isDisabled: isDisabled || !isValid || !(isDirty || canSaveUnchanged), __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
, "Save"

          )
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: cancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}, "Cancel")
          , _react2.default.createElement('span', { className: "team-page--form-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}},  draft.length , " / "  ,  _message.MAX_AUTOREPLY_MSG_LENGTH )
        )
    )
  )
}

exports. default = MessageForm
